import { render, staticRenderFns } from "./TaskChangePriority.vue?vue&type=template&id=4ba44409&scoped=true&lang=pug&"
import script from "./TaskChangePriority.vue?vue&type=script&lang=js&"
export * from "./TaskChangePriority.vue?vue&type=script&lang=js&"
import style0 from "./TaskChangePriority.vue?vue&type=style&index=0&id=4ba44409&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba44409",
  null
  
)

export default component.exports